var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"border rounded bg-white"},[_c('b-table',{staticClass:"mb-0",attrs:{"borderless":"","hover":"","primary-key":"index","items":_vm.test.subtests,"fields":_vm.fields}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }